import { useState } from 'react';
import {
    FileEarmarkArrowDownFill as Download_Icon,
    FileX as Error_Icon,
} from 'react-bootstrap-icons';
import { Spinner } from 'react-bootstrap';

import './FunctionCell_Download.scss';

export default function FunctionCell_Download(props) {
    const [stateOfDownload, setStateOfDownload] = useState('NONE');

    function onDownload() {
        setStateOfDownload('LOADING');
        props.cellFunctions.onDownload(props.value, onResult);
    }

    function onResult(result) {
        setStateOfDownload((result) ? 'NONE' : 'ERROR')
    }

    return (
        <div div className="gridFunctionCell" >
            {
                (stateOfDownload === 'NONE') &&
                <Download_Icon width={24} height={24} onClick={onDownload} />
            }
            {
                (stateOfDownload === 'LOADING') &&
                <Spinner variant='danger' size='sm' />
            }
            {
                (stateOfDownload === 'ERROR') &&
                <Error_Icon width={24} height={24} onClick={onDownload} />
            }
        </div>
    )
}
